import React from 'react';
import { bool, func, number, string } from 'prop-types';
import './SkillGeoComment.scss';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import classnames from 'classnames';

const MAX_LENGTH = 1000;

export class SkillGeoComment extends React.Component {
  static propTypes = {
    comment: string,
    includeComment: bool,
    toggleIncludeComment: func,
    setComment: func,
    geoDifferential: number,
    skillDifferential: number,
    hasChanges: bool
  };

  constructor(props) {
    super(props);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { geoDifferential, skillDifferential, hasChanges, comment, includeComment } = this.props;

    if (
      hasChanges &&
      (geoDifferential !== prevProps.geoDifferential || skillDifferential !== prevProps.skillDifferential)
    ) {
      this.generateComment();
    }

    if (
      (!hasChanges && !includeComment && geoDifferential && comment.length === 0) ||
      (skillDifferential && comment.length === 0)
    ) {
      this.generateComment();
    }
  }

  onInputChange(event) {
    const { value } = event.target;
    const { setComment } = this.props;
    setComment(value);
  }

  generateComment() {
    const { geoDifferential, skillDifferential, setComment } = this.props;
    let comment = '';
    const hasGeo = geoDifferential !== null && !isNaN(geoDifferential);
    const hasSkill = skillDifferential !== null && !isNaN(skillDifferential);
    if (hasGeo) {
      comment += `Changed geo factor to ${this.formatDifferential(
        geoDifferential
      )} using PayScale Differentials feature`;
    }
    if (hasGeo && hasSkill) {
      comment += '\n\n';
    }
    if (hasSkill) {
      comment += `Changed skill factor to ${this.formatDifferential(
        skillDifferential
      )} using PayScale Differentials feature`;
    }
    setComment(comment);
  }

  formatDifferential(differential) {
    return (1.0 + differential).toFixed(3);
  }

  render() {
    const { includeComment, toggleIncludeComment, comment } = this.props;
    const commentClasses = classnames({
      'skill-geo-comment__container': true,
      disabled: !includeComment
    });
    return (
      <div className={commentClasses}>
        <div className="checkbox__container">
          <CheckboxInput checked={includeComment} onClick={toggleIncludeComment} />
          <span className="label">Add Comment to Selected Matches</span>
        </div>
        <div className="comment__textarea">
          <textarea
            disabled={!includeComment}
            maxLength={MAX_LENGTH}
            value={comment}
            onChange={this.onInputChange}
          ></textarea>
        </div>
        <div className="warning__text">Any existing comments for selected matches will be overwritten</div>
      </div>
    );
  }
}

export default SkillGeoComment;
